/**
 * Format remaining seconds into a human-readable time string
 * @param seconds - The number of seconds to format
 * @returns Formatted time string (e.g., "2h 30m", "5m", "45s")
 */
export const formatDuration = (seconds: number): string => {
  if (seconds < 60) return `${seconds}s`;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  // if displaying only minutes; add minute for better UX
  // if we don't, we will see 1m when there is 1:59 left, and so on
  return `${minutes + 1}m`;
};
